import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoaderData from '../../../../../../Bookings/Components/Modals/AirportTransfer/LoaderData';
import AddAndUpdateClient from '../Client';
import AddAndUpdateVendor from '../Vendor';
import AddAndUpdateAirport from '../Airport';
import AddAndUpdateZones from '../Zones';

const InventoryActions = ({ currentSelectedInventory, currentActiveBookingAction, setCurrentActiveBookingAction }) => {
  /* ---------------------------- LOCAL STATE ---------------------------- */
  const [isClientCreation, setIsClientCreation] = useState(false);
  const [isVendorCreation, setIsVendorCreation] = useState(false);
  const [isAirportCreation, setIsAirportCreation] = useState(false);
  const [isZoneCreation, setIsZoneCreation] = useState(false);
  const [isClientUpdation, setIsClientUpdation] = useState(false);
  const [isVendorUpdation, setIsVendorUpdation] = useState(false);
  const [isAirportUpdation, setIsAirportUpdation] = useState(false);
  const [isZoneUpdation, setIsZoneUpdation] = useState(false);

  useEffect(() => {
    if (currentActiveBookingAction !== null) {
      switch (currentActiveBookingAction) {
        case 'create_client':
          setIsClientCreation(true);
          break;
        case 'create_vendor':
          setIsVendorCreation(true);
          break;
        case 'create_airport':
          setIsAirportCreation(true);
          break;
        case 'create_zone':
          setIsZoneCreation(true);
          break;
        case 'update_client':
          setIsClientUpdation(true);
          break;
        case 'update_vendor':
          setIsVendorUpdation(true);
          break;
        case 'update_airport':
          setIsAirportUpdation(true);
          break;
        case 'update_zone':
          setIsZoneUpdation(true);
          break;
      }
    }
  }, [currentActiveBookingAction]);

  return (
    <>
      {isClientCreation && (
        <AddAndUpdateClient
          currentSelectedInventory={null}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={false}
        />
      )}

      {isClientUpdation && (
        <AddAndUpdateClient
          currentSelectedInventory={currentSelectedInventory?.[0]}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={true}
        />
      )}

      {isVendorCreation && (
        <AddAndUpdateVendor
          currentSelectedInventory={null}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={false}
        />
      )}

      {isVendorUpdation && (
        <AddAndUpdateVendor
          currentSelectedInventory={currentSelectedInventory?.[0]}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={true}
        />
      )}

      {isZoneCreation && (
        <AddAndUpdateZones
          currentSelectedInventory={null}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={false}
        />
      )}

      {isZoneUpdation && (
        <AddAndUpdateZones
          currentSelectedInventory={currentSelectedInventory?.[0]}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={true}
        />
      )}

      {isAirportCreation && (
        <AddAndUpdateAirport
          currentSelectedInventory={null}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={false}
        />
      )}

      {isAirportUpdation && (
        <AddAndUpdateAirport
          currentSelectedInventory={currentSelectedInventory?.[0]}
          onClose={() => {
            setCurrentActiveBookingAction(null);
          }}
          isUpdate={true}
        />
      )}
    </>
  );
};

export default InventoryActions;
